(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name flyingHourSummaryReport.controller:FlyingHourSummaryReportCtrl
   *
   * @description
   *
   */
  angular
    .module('flyingHourSummaryReport')
    .controller('FlyingHourSummaryReportCtrl', FlyingHourSummaryReportCtrl);

  function FlyingHourSummaryReportCtrl(CommonMasterData,CommonLogicService,$sce,MessageService, applicationConstants) {
    var vm = this;
    vm.ctrlName = 'FlyingHourSummaryReportCtrl';
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewType : null,
        aircraftModel : null,
        excludeOtherHubCrew:false,
        crewBase : null,
        carriers:null,
        status :{title:'Active', value: 'ACT'},
        crewIds: null
			},
			masterList : {
				crewTypeList : [],
				yearList : [],
				monthList : [],
        crewIdsList : [],
        crewBaseList :[],
        aircraftTypes : [],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        carriers : [],
        statusList : [
          {title:'Active', value: 'ACT'},
          {title:'Inactive', value: 'INA'},
          {title:'All', value: 'ALL'}
        ]
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null,
      total: false
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchFlyingReport(params);
		};


    // on change search field
    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
      if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
        //searchParams.toDate = tempFromDate;
      }
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      }
    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
        vm.model.masterList.fromDateAfterFromDate = false;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
        vm.model.masterList.fromDateAfterToDate = false;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date) {
      return (!!date && !moment(date, "DD/MM/YYYY",true).isValid()) ;
    }

    // check from date and to date
    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate,"DD/MM/YYYY").isBefore(moment(vm.model.searchCriteria.fromDate,"DD/MM/YYYY"));
    }
    ;



		function searchFlyingReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;

        var url = ""
        if(param.total){
          url = CommonLogicService.getReportUrl(
            'flying_hours_total_summary_report.rptdesign',
            getSearchParamMap(param));
        }else {
          url = CommonLogicService.getReportUrl(
            'flying_hours_summary_report.rptdesign',
            getSearchParamMap(param));
        }
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			searchParamMap["crewType"] = param.crewType.crewTypeCode;
      searchParamMap["crewBase"] = (!!param.crewBase && !!param.crewBase.airPortCode) ? param.crewBase.airPortCode:'';
      searchParamMap["aircraftModel"] = (!!param.aircraftModel && !!param.aircraftModel.modelNumber) ? param.aircraftModel.modelNumber:'';
      searchParamMap["excludeOtherHubCrew"] = param.excludeOtherHubCrew;
      searchParamMap["crewIdList"] = param.crewIds;
      searchParamMap["carrier"] = '';
      if (!!param.carriers && !!param.carriers.code) {
        searchParamMap["carrier"] = param.carriers.code;
      }

      if (!!param.status && !!param.status.value) {
        searchParamMap["status"] = param.status.value;
      }

			return searchParamMap;
		}

    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (vm.model.masterList.toDateFormatInvalid
        || vm.model.masterList.fromDateFormatInvalid) {
        return false;
      } else if (istoDateBeforeFromDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
        return false;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
        return true;
      }
    }


		(function() {
			// crew type master codes
			CommonMasterData.getCrewTypeList(function(crewTypeList){
			      vm.model.masterList.crewTypeList = crewTypeList;
			},function () {});


			// year List
			CommonMasterData.getYearList(function(yearList) {
				vm.model.masterList.yearList = yearList;
				var a = moment().format('YYYY');
				vm.model.searchCriteria.year = _.find(yearList, function(year) {
					return year.desc == moment().format('YYYY');
				});
			}, function() {
				console.log('Year List retrieval error');
			});

			// Month List
			CommonMasterData.getMonthList(function(monthsOfYear) {
				vm.model.masterList.monthList = monthsOfYear;
				vm.model.searchCriteria.month = _.find(monthsOfYear, function(
						month) {
					return month.desc === moment().format('MMM');
				});
			}, function() {
				console.log('Month list retrieval error');
			});

      CommonMasterData.getAircraftModelList(function(aircrafts) {
        vm.model.masterList.aircraftTypes = aircrafts;
      }, function() {
        console.log('Aircraft types retrieval error');
      });

      CommonMasterData.searchCarriers(
        function (response) {
          for(var index in response.hubCodes) {
            vm.model.masterList.carriers.push({"code":response.hubCodes[index],"name":response.hubCodes[index]});
          }
        },
        function (error) {
          MessageService.error(error);
        }
      );

      // base list
      CommonMasterData.getCrewBaseList(function(crewBases) {
        vm.model.masterList.crewBaseList = crewBases;
      }, function() {
        console.log('Crew Base List retrieval error');
      });


		})();
  }
}());
